import React from "react"
import styled from "styled-components"
import { Paper } from "@mui/material"
import { theme } from "../../../theme"
import { Heading2 } from "../../atoms/text"
import { ShortFormInput } from "./ShortFormInput"
import { ShortFormElement } from "./types/ShortFormElement"

export type ShortFormProps = {
  title?: string
  elements: ShortFormElement[]
}

export const ShortForm = (props: ShortFormProps) => {
  const { title, elements } = props

  return (
    <Container>
      {title && <Heading2>{title}</Heading2>}
      <CardRows>
        {elements.map((element, elementIndex) => (
          <CardRow key={`element-${elementIndex}`}>
            <CardRowColumnLeft>{element.label}</CardRowColumnLeft>
            <CardRowColumnRight>
              <ShortFormInput element={element} />
            </CardRowColumnRight>
          </CardRow>
        ))}
      </CardRows>
    </Container>
  )
}

const Container = styled(Paper)`
  padding: ${theme.spacing.lx};
  background-color: ${theme.color.white};
`

const CardRows = styled.div`
  margin-top: ${theme.spacing.lx};
`

const CardRow = styled.div`
  padding: ${theme.spacing.lx} 0;
  border-bottom: 1px solid ${theme.color.white1};

  :last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  display: grid;
  grid-template-columns: minmax(30%, 250px) 70%;

  ${theme.mui.breakpoints.down("md")} {
    grid-template-columns: minmax(40%, 250px) 60%;
  }

  ${theme.mui.breakpoints.down("sm")} {
    grid-template-columns: minmax(50%, 250px) 50%;
  }
`

const CardRowColumnLeft = styled.div`
  color: ${theme.color.black4};
`

const CardRowColumnRight = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`
